module.exports = __webpack_public_path__ + "img/send-tx-left.e2593f8c.png";